module.exports = __webpack_public_path__ + "static/media/IMPACT_YOUTH_LIVEVIBE_3-TheDukeLDN.d615eb6e.jpg";